/** Reviewed language for generated preferences; these lines assert no past
 * events, possessions, favors, or promises. Interaction capabilities stay in
 * npcInteraction; transient relationships never become profile text. */
import { NPC_INTERESTS, npcPersonalityResponse, type NpcPersonality, type NpcPersonalValue } from "./personality.js";

const VALUES: Readonly<Record<NpcPersonalValue, { statement: string; detail: string; advice: string }>> = {
  mastery: { statement: "Doing things well matters to me.", detail: "There's satisfaction in understanding the difficult part.", advice: "Learn why something works before you try to improve it." },
  loyalty: { statement: "Showing up for people matters to me.", detail: "Small, dependable acts mean a great deal.", advice: "Make time for the people who count on you." },
  fairness: { statement: "Giving people a fair chance matters to me.", detail: "I want to understand both sides before deciding.", advice: "Hear both sides before you decide who's right." },
  security: { statement: "Having something dependable matters to me.", detail: "A little preparation makes uncertainty easier to face.", advice: "Leave yourself a little room for things to go wrong." },
  autonomy: { statement: "Being able to choose my own way matters to me.", detail: "Help means more when there's room to say no.", advice: "Listen to advice, then make the choice you can stand behind." },
  recognition: { statement: "Having my efforts recognized matters to me.", detail: "I want to do something worth remembering.", advice: "Give people a chance to see what you can do." },
};

export function npcPersonalityDialogue(profile: NpcPersonality, topic: "interest" | "values" | "advice"): string {
  if (topic === "interest") {
    const interest = NPC_INTERESTS[profile.interest];
    const response = npcPersonalityResponse(profile, {
      kind: "question", audience: "unknown", pressure: "unknown", reliability: "unknown",
    });
    return interest.brief + (profile.expression.length === "conversational" || response.approach === "invite_question"
      ? ` ${interest.detail}` : "");
  }
  const value = VALUES[profile.values[0]];
  if (topic === "values") {
    return value.statement + (profile.expression.length === "conversational" ? ` ${VALUES[profile.values[1]].detail}` : "");
  }
  const lead = profile.dispositions.politeness >= 65 ? "If I may suggest something: "
    : profile.dispositions.assertiveness < 40 ? "For what it's worth: " : "";
  const advice = lead ? value.advice[0].toLowerCase() + value.advice.slice(1) : value.advice;
  const aside = profile.expression.length === "brief" ? "" : profile.expression.manner === "dry"
    ? " Easy enough to say, of course." : profile.expression.manner === "gentle" ? " Give yourself time." : "";
  return lead + advice + aside;
}
